/**
 * This script should be called once (e.g. on the main layout), and it will
 * apply to all elements with the floating-menu class.
 * 
 * @usage <details class="floating-menu"></details>
 */
document.body.addEventListener('click', (e) => {
    const myFloatingMenu = e.target.closest('details.floating-menu')
    document.querySelectorAll('details.floating-menu').forEach((menu) => {
        if (myFloatingMenu !== menu)
            menu.open = false
    })
})
